<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Products Master Data Import</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-file-input
              name="productExcelFile"
              v-model="excelFile"
              label="Browse Excel Sheet"
              outlined
              dense
            ></v-file-input>
          </v-col>

          <!-- <v-col cols="12" xs="12" sm="12" md="4">
            <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
          </v-col>-->

          <v-col cols="12">
            <v-btn color="primary" @click="uploadExcel" :loading="$store.state.btnLoader">
              <v-icon left>mdi-upload</v-icon>Upload
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    search: "",
    loader: false,
    excelFile: null,
    date: null
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    uploadExcel() {
      var store_id = localStorage.getItem("store_id");
      var subscriber_id = localStorage.getItem("subscriber_id");

      console.log("store_id", store_id);
      console.log("subscriber_id", subscriber_id);

      const data = new FormData();
      data.append("documentData", this.excelFile);
      data.append("store_id", parseInt(store_id));
      data.append("subscriber_id", parseInt(subscriber_id));
      this.$store.commit("btnLoader", true);
      const url = "/product-import-documents";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show(
              "Products imported successfully",
              "green"
            );
            self.$store.commit("btnLoader", false);
            self.excelFile = null;
          } else {
            self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
      // end
    }
  }
};
</script>